import { render } from "./GivingSection.vue?vue&type=template&id=57c98c8e"
import script from "./GivingSection.vue?vue&type=script&lang=js"
export * from "./GivingSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__